import { OnInit, Component} from "@angular/core";
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { TraceClassDecorator } from "@sentry/angular";
import { ProviderStateService } from "src/app/services/provider-state.service";


@TraceClassDecorator()
@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})
export class UserListComponent implements OnInit {
  slug: string = "";
  constructor(
    private readonly breadcrumbService: DoctorBreadcrumbService,
    private readonly providerstateService: ProviderStateService
  ) {
    
  }

  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'support'] },
      { label: 'User List' },
      { label: 'Support' }
    ]);

  }

}
